import React from 'react'

const Industry = () => {
  return (
    <div>Industry</div>
  )
}

export default Industry